<template>
  <div class="app__content section">
    <div class="section__wrapper">
      <div class="section__content">
        <div v-if="!registrationSuccess" class="section__copy">
          <h2>Registration</h2>
          <p class="">Thank you for participating. The videos you upload will be added to the video database and will be used to populate britaintakeabow.org</p>
          <p><router-link :to="{ name: 'view-about' }">Find out more about the project</router-link></p>
          <p>Please complete the fields below:</p>
        </div>
        <form v-if="!registrationSuccess" class="form" @submit.prevent="submit()">
          <div class="form__group">
            <label class="form__label" for="name">Name</label>
            <div class="form__input-group">
              <input
                :class="{ 'form__input--error': $v.auth.firstName.$error }"
                v-model="auth.firstName"
                @input="handleFieldInput('firstName')"
                class="form__input" name="name" type="text"
                placeholder="First name"
              >
              <input
                :class="{ 'form__input--error': $v.auth.lastName.$error }"
                v-model="auth.lastName"
                @input="handleFieldInput('lastName')"
                class="form__input" name="name" type="text"
                placeholder="Last name"
              >
            </div>
            <span
              v-if="$v.auth.firstName.$error || $v.auth.lastName.$error"
              class="form__help form__help--error"
            >
              These fields are required.
            </span>
          </div>

          <div class="form__group">
            <label class="form__label" for="email">Email</label>
            <div class="form__input-group">
              <input
                :class="{ 'form__input--error': $v.auth.username.$error }"
                v-model="auth.username"
                @input="handleFieldInput('username')"
                class="form__input" name="email" type="email"
                placeholder="Your email address">
            </div>
            <span class="form__help">You'll need to confirm that this email address belongs to you</span>
            <span
              v-if="$v.auth.username.$error"
              class="form__help form__help--error"
            >
              This field is required. Please use a valid email address.
            </span>
          </div>

          <div class="form__group">
            <label class="form__label" for="password">Password</label>
            <span class="form__help">(required when you upload your videos)</span>
            <div class="form__input-group">
              <input
                :class="{ 'form__input--error': $v.auth.password.$error }"
                v-model="auth.password"
                @input="handleFieldInput('password')"
                class="form__input" name="password" type="password"
                placeholder="Password">
              <input
                :class="{ 'form__input--error': $v.auth.passwordConfirm.$error }"
                v-model="auth.passwordConfirm"
                @input="handleFieldInput('passwordConfirm')"
                class="form__input" name="passwordConfirm" type="password"
                placeholder="Confirm password">
            </div>
            <span class="form__help">Use 8 or more characters with a mix of letters, numbers &amp; symbols</span>
            <span
              v-if="$v.auth.password.$error || $v.auth.passwordConfirm.$error"
              class="form__help form__help--error"
            >
              Your password must be 8 or more characters. Password confirmation must match password.
            </span>
          </div>

          <div class="form__group">
            <label class="form__label" for="links">Links</label>
            <div class="section__copy">
              <span class="form__help">We'll credit you at the end of the video. Please add links to your website, Twitter, Facebook profile, Instagram etc below</span>
            </div>
            <div class="form__input-group">
              <input
                v-model="auth.credit"
                class="form__input" name="links" type="text"
                placeholder="Separate urls with commas">
            </div>
            <span class="form__help">We'll replace web links, twitter handles with clickable links</span>
          </div>

          <div class="form__group">
            <button type="submit" class="button form__submit">
                Register
            </button>
            <p class="form__link mr-2" v-if="authMessage">{{ authMessage }}</p>
          </div>
        </form>
        <div v-if="registrationSuccess">
          <h2>Registration successful</h2>
          <p>Thank you for registering, your account is now awaiting approval. Once approved, you will be notified by email and will be able to log in and upload videos.</p>
        </div>
        <router-link class="form__link" :to="'login'">Login</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { Register } from '@/services/api';
import { required, email, minLength, sameAs } from 'vuelidate/lib/validators';

const touchMap = new WeakMap();

export default {
  name: 'register',
  data() {
    return {
      auth: {
        firstName: '',
        lastName: '',
        username: '',
        password: '',
        passwordConfirm: '',
        credit: '',
      },
      authError: false,
      authMessage: '',

      registrationSuccess: false,
    };
  },
  validations: {
    auth: {
      username: { required, email },
      firstName: { required },
      lastName: { required },
      password: { required, minLength: minLength(8) },
      passwordConfirm: { required, sameAsPassword: sameAs('password') },
    },
  },
  computed: {
    authPayload() {
      return {
        fullname: `${this.auth.firstName} ${this.auth.lastName}`,
        username: this.auth.username,
        password: this.auth.password,
        credit: this.auth.credit,
      };
    },
    authFieldError() {
      return this.$v.auth.username.$error ||
      this.$v.auth.firstName.$error ||
      this.$v.auth.lastName.$error ||
      this.$v.auth.password.$error ||
      this.$v.auth.passwordConfirm.$error;
    },
  },
  methods: {
    handleFieldInput(field) {
      if (this.auth[field]) {
        this.$v.auth[field].$reset();
        if (touchMap.has(this.$v.auth[field])) {
          clearTimeout(touchMap.get(this.$v.auth[field]));
        }
        touchMap.set(this.$v.auth[field], setTimeout(this.$v.auth[field].$touch, 1000));
      }
    },
    submit() {
      this.authError = false;
      this.$v.auth.username.$touch();
      this.$v.auth.password.$touch();
      this.$v.auth.passwordConfirm.$touch();
      this.$v.auth.firstName.$touch();
      this.$v.auth.lastName.$touch();

      if (this.authFieldError) return;

      Register(this.authPayload).then((res) => {
        if (res) {
          this.authMessage = 'Thank you for registering, once your account has been approved you will be able to log in.';
          this.auth = {
            firstName: '',
            lastName: '',
            username: '',
            password: '',
            passwordConfirm: '',
            credit: '',
          };
          this.$v.auth.username.$reset();
          this.$v.auth.password.$reset();
          this.$v.auth.passwordConfirm.$reset();
          this.$v.auth.firstName.$reset();
          this.$v.auth.lastName.$reset();

          this.registrationSuccess = true;
        }
      })
      .catch((err) => {
        this.authError = true;
        this.authMessage = `Sorry, something went wrong: ${err.data.Error}`;
      });
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// register.vue?90835820